var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quad__block__child image"},[_c('img',{staticClass:"single__image",attrs:{"src":_vm.single_image,"alt":"poster"}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/edc.stagingwebsite.dev/web/app/themes/edc/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/edc.stagingwebsite.dev/web/app/themes/edc/node_modules/vue-loader/lib?{}!./scripts/vue/SingleImage.vue?vue&type=template&id=458bc058&scoped=true&
// module id = 250
// module chunks = 0